export default __webpack_public_path__ + "static/media/disco_death_race_icon.270b6659.png";